import styled, { withTheme } from 'styled-components';
import Colours from './styled/Colours';
import { Link } from './styled/Text';
import { isDisplayedInIframe } from './styled/Theme';
import { Theme } from '../../types/theme';

const ThemeFooter = styled.footer`
  background: ${Colours.lightGrey20};
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 70px;
  padding: 10px 16px;
  text-align: center;
  p {
    margin-bottom: 0;
    text-align: center;
  }
`;

type Props = {
  policyUrl: string;
  theme: Theme;
};

const Footer = ({ policyUrl, theme }: Props) =>
  !isDisplayedInIframe(theme) && policyUrl ? (
    <ThemeFooter className="footer">
      <p className="text14 mb-3">
        For more details on returns please see our&nbsp;
        <Link href={policyUrl} target="_blank" rel="noopener noreferrer">
          return policy
        </Link>
      </p>
    </ThemeFooter>
  ) : null;

export default withTheme(Footer);
